import axios from 'axios'
import auth from './Auth'

import { isSystemLogin } from "./helpers"

import appConfig from './Config'

const restV2 = (baseURL) => {
    let instance = axios.create({
        baseURL: baseURL,
        withCredentials: false,
    });
    instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    /**
     * Request Interceptor
     */
    instance.interceptors.request.use(config => {
        const now = new Date();
        const timeString = now.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
        localStorage.setItem('logoutTime', timeString)
console.log(auth.get(true))
        if (auth.get() != null && auth.get() !== 'null') config.headers.common.Authorization = `Bearer ${auth.get(true)}`;

        if (window.localStorage.batch) {
            const batch = JSON.parse(window.localStorage.batch);
            config.headers.common.batch = batch.id;
        }

        config.headers.common.domain = location.host;

        if (appConfig.APP_ENV === 'QA') {
            config.headers.common.domain = 'eacademy.sahakaryatech.com';
        }

        if (appConfig.APP_ENV !== 'QA' && appConfig.APP_ENV !== 'LIVE' && appConfig.APP_ENV !== 'DEV') {
            config.headers.common.domain = appConfig.APP_ENV;
        }
        if(isSystemLogin()) {
            if(window.localStorage._selectedCompany) {
                const selectedComany = JSON.parse(window.localStorage._selectedCompany);
                config.headers.common.domain = 'system.'+selectedComany.domain;
            }
        }


        let role = window.localStorage._role;
        if (role) {
            config.headers.common.Role = role;
        }
        if (role === 'accountant') {
            if (window.localStorage._currentFiscalYear) {
                const fiscal_year = JSON.parse(window.localStorage._currentFiscalYear);
                config.headers.common.FiscalYear = fiscal_year.id;
            }
        }
        return config
    }, error => {
        return Promise.reject(error);
    });

    /**
     * Response Interceptor
     */
    instance.interceptors.response.use(response => {
        return response;
    }, error => {
        if (error.response) {
            if (error.response.status === appConfig.rest.UNAUTHORIZED) {
                return Promise.reject("Communication Failed with v2 services. Please contact system administrator.");
            }
        }
        return Promise.reject(error);
    });

    return instance;
}



export default () => {
    return restV2;
}
